import React from "react";
import {Grid} from "@mui/material";
import PropertyCard from "../../Cards/PropertyCard";
import bg from "../../SVG/Circle-270.svg"
import CustomHorizontalSpace from "../../Assistants/SpaceAssistant";
import {Colors} from "../../../resources/Colors";

export function OverviewImmunoClustProps(){
    return <>
        <CustomHorizontalSpace space={100}/>
        <div style={{display:"flex" , alignItems:"flex-start" , flexDirection:"column" , marginLeft:'10%' , marginRight:'10%'}}>
            <h1 className={"heading"}>iCAP</h1>
            <div className={"line"}></div>
            <h2> Clustering, Population Identification and Quantification
            </h2>
        </div>
        <CustomHorizontalSpace space={100}/>
        <Grid container spacing={6} >
            <Grid item xs={12} >
                <Grid container direction={'row'} spacing={4} style={{backgroundImage: `url(${bg})` ,backgroundRepeat:'no-repeat', backgroundPosition:'center'}} >
                    <Grid item xs={6}>
                        <Grid container direction="column"
                              justifyContent="space-around"
                              alignItems="flex-end"
                              spacing={3}>
                            <Grid item>
                                <PropertyCard title={"CELL-EVENT clustering"} icon={"fa-solid fa-magnifying-glass fa-3x"}  color={Colors.bioretisBlue} text={"Detection of groups of cells with similar staining characteristics in an individual sample"}  />
                            </Grid>
                            <Grid item >
                                <PropertyCard title={"META-CLUSTER-Annotation"} icon={"fa-regular fa-bars-sort fa-3x"} color={Colors.bioretisBlue} text={"Staining dependent hierarchical sorting and characterization of cell (sub-) populations"}  />
                            </Grid>
                            <Grid item>
                                <CustomHorizontalSpace space={100}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container direction="column"
                              justifyContent="space-around"
                              alignItems="flex-start"
                              spacing={3}>

                            <Grid item >
                                <CustomHorizontalSpace space={100}/>
                            </Grid>
                            <Grid item >
                                <PropertyCard title={"META clustering"} icon={"fa-sharp fa-regular fa-circle-nodes fa-3x"} fontFamily={"sharp"} color={Colors.bioretisBlue} text={"Matching of cell populations (clusters) with similar staining characteristics between multiple samples"}  />
                            </Grid>
                            <Grid item>
                                <PropertyCard title={"CELL-TYPE Quantification"} icon={"fa-light fa-chart-tree-map fa-3x"} color={Colors.bioretisBlue} text={"Absolute and relative quantification of populations by numbers of cells per cluster, variability of markers per cluster and comparison with healthy reference"}  />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {/*<Grid item xs={12} md={6} style={{display:'flex', justifyContent:'center' , alignItems:'center'}} >
                <Grid container direction={'column'}>
                    <Grid item xs={12} style={{display:'flex', justifyContent:'center',marginBottom:'30px'}}>
                        <h2> immunoClust Properties</h2>
                    </Grid>
                    <Grid item xs={12} style={{display:'flex', justifyContent:'space-between' , alignItems:'center', marginLeft:'25%', marginRight:'25%'}}>
                        <p align={'justify'}>
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
                        </p>

                    </Grid>
                </Grid>
            </Grid> */}
        </Grid>
        <CustomHorizontalSpace space={100}/>





    </>


}export default OverviewImmunoClustProps